"use client"

import { useState, useEffect } from "react"

/**
 * Detects if the user is on an iOS device (iPhone, iPad, iPod).
 * Uses a hook to avoid SSR/hydration mismatch - returns false during SSR and initial
 * client render, then updates after mount.
 *
 * Native HTML date inputs work reliably on iOS Safari, while custom Popover/Calendar
 * date pickers have known touch and focus issues (Radix #2478, react-day-picker).
 */
export function useIsIOS(): boolean {
    const [isIOS, setIsIOS] = useState(false)

    useEffect(() => {
        setIsIOS(
            typeof navigator !== "undefined" &&
                /iPad|iPhone|iPod/.test(navigator.userAgent)
        )
    }, [])

    return isIOS
}
